import type { TrackingEventName } from "./TrackingEventName";

export enum TrackedLoadedPageName {
  Home = "Home",
  HotelAvailability = "HotelAvailability",
  HotelCover = "HotelCover",
  HotelRoomSelection = "HotelRoomSelection",
  HotelCheckout = "HotelCheckout",
  HotelCheckoutTravelerInformation = "HotelCheckoutTravelerInformation",
  HotelCheckoutPayment = "HotelCheckoutPayment",
  HotelCheckoutCartReview = "HotelCheckoutCartReview",
  HotelBookingConfirmation = "HotelBookingConfirmation",
  TripsList = "TripsList",
  TripDetails = "TripDetails",
  HotelCancellation = "HotelCancellation",
  AuthVerification = "AuthVerification",
  AuthMFAVerification = "AuthMFAVerification",
}

export type PageOpenedEventTrackingProperties = {
  landing_screen: TrackedLoadedPageName;
  URL: string;
};

export type PageOpenedEvent = {
  name: TrackingEventName.launched_application;
  properties: PageOpenedEventTrackingProperties;
};
